import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53069)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M49.9994 25H-0.000488281V9.48271C-0.000488281 9.00664 0.385546 8.62061 0.861619 8.62061H49.1374C49.6135 8.62061 49.9995 9.00664 49.9995 9.48271L49.9994 25Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M1.72363 25.0003V24.1382H-0.000488281V25.0003V25.8624V40.5175C-0.000488281 40.9936 0.385546 41.3797 0.861619 41.3797H49.1374C49.6135 41.3797 49.9995 40.9936 49.9995 40.5175V25.0003H1.72363Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.5168 25H0.861619C0.385546 25 -0.000488281 24.6139 -0.000488281 24.1379V9.48271C-0.000488281 9.00664 0.385546 8.62061 0.861619 8.62061H15.5168C15.9928 8.62061 16.3789 9.00664 16.3789 9.48271V24.1379C16.3788 24.6139 15.9928 25 15.5168 25Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.521 13.1338L9.34288 15.5981L11.9405 15.6182C12.2769 15.6207 12.4163 16.05 12.1457 16.2497L10.0561 17.7928L10.8396 20.2695C10.9409 20.5902 10.5759 20.8554 10.3023 20.6599L8.18897 19.1494L6.0756 20.66C5.80197 20.8556 5.43693 20.5902 5.53829 20.2696L6.32179 17.7929L4.23214 16.2498C3.96154 16.05 4.10099 15.6208 4.43732 15.6183L7.03497 15.5982L7.85685 13.1339C7.96329 12.8148 8.41466 12.8148 8.521 13.1338Z",
					fill: "#F3F3F3"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53069",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgClFlag);
export { ForwardRef as ReactComponent };
